import { docIdCodes, transferDocs } from "../../../data/docCodes";
import { stdObject } from "../../../data/types/stdObject";

export const checkAccess = (type: string, packData: stdObject) => {
  const { docValues, userAccess } = packData;
  if (!("sectionId" in docValues) || !docValues.sectionId) return false;
  const origin = userAccess[docValues.sectionId[0]];
  switch (type) {
    case "guarantee":
      return (
        docValues.type === "SEV" &&
        docValues.code > 0 &&
        docValues.data.GARSEV.value === "" &&
        userAccess[docValues.sectionId[0]].C1G
      );
    case "edit":
      return origin[docValues.sectionId] > 1;
    case "void":
      return docValues.code > 0 && origin[docValues.sectionId] === 3;
    case "transfer":
      const transferCodes =
        transferDocs[docValues.type as keyof typeof transferDocs];
      return (
        docValues.code > 0 &&
        transferCodes &&
        transferCodes.filter((e: string) => {
          const idCode = docIdCodes[e];
          return idCode ? userAccess[idCode[0]][idCode] : false;
        }).length > 0
      );
    case "print":
      return origin[`${docValues.sectionId}P`] !== 0;
    default:
      return false;
  }
};
